import PessoaService from "business/cadastro/pessoa/pessoa/pessoaService"
import { isValidCpf } from "helper/checker"
import { boolToNumber, toJSDate } from "helper/formater"
import { justNumbers } from "helper/parser"
import * as yup from "yup"

export default class PessoaFisicaService extends PessoaService {

    title = "Pessoa física"
    pluralTitle = "Pessoas físicas"
    url = '/cadastro/pessoa/pessoafisica'
    frontUrl = '/cadastro/pessoa/pessoafisica'
    frontUrlList = '/cadastro/pessoa/pessoafisicalist'
    primaryKey = 'codigo_pef'
    ignoredsSchemaConvertions = ['cod_esco_pef', 'cod_hobb_pef', 'cod_esci_pef', 'cod_sexo_pef', 'cod_prof_pef', 'cod_grup_pes', 'cod_catp_pes', 'cod_clap_pes']
    // icon = 'pi pi-id-card' // Não inclua pi-fw

    postDTO(data = {}) {

        data.pessoa.tel_cel_pes = justNumbers(data.pessoa.tel_cel_pes)
        data.pessoa.tel_comercial_pes = justNumbers(data.pessoa.tel_comercial_pes)

        return data

    }
    prepareToFront(data = {}) {

        console.log('DATA:', data)

        // Garante a presença de pessoa e pessoa_endereco no Novo
        data.pessoa = data.pessoa || {}
        data.pessoa.ie_pes = data.pessoa.ie_pes || ''

        data.pessoa.pessoa_endereco = data.pessoa?.pessoa_endereco || []
        data.pessoa.cli_atac_pes = data.pessoa.cli_atac_pes || 0
        data.emis_rg_pef = toJSDate(data.emis_rg_pef)
        data.nasc_pef = toJSDate(data.nasc_pef)
        data.renda_mes_pef = data.renda_mes_pef || null

        if (data.pessoa?.pessoa_endereco) {
            data.pessoa.pessoa_endereco.forEach(e => {
                e.usa_desde_ende = toJSDate(e.usa_desde_ende)
            })
        }

        return data
    }

    async getById(args = {}) {

        args.includes = args.includes || 'pessoa_fisica,pessoa_endereco_tipo'
        return super.getById(args).then((response) => {
            // response.data = this.prepareToFront(response.data)
            return response
        })

    }

    prepareToSave({ data }) {

        data.cod_esci_pef = data.cod_esci_pef?.codigo_esci || null
        data.cod_sexo_pef = data.cod_sexo_pef?.codigo_sexo || null
        data.cod_prof_pef = data.cod_prof_pef?.codigo_prof || null
        data.cod_esco_pef = data.cod_esco_pef?.codigo_esco || null
        data.cod_hobb_pef = data.cod_hobb_pef?.codigo_hobb || null
        data.pessoa.reter_iss_pes = boolToNumber(data.pessoa.reter_iss_pes)
        data.pessoa.cli_atac_pes = boolToNumber(data.pessoa.cli_atac_pes)
        data.pessoa.blq_venda_ate_pes = data.pessoa.blq_venda_ate_pes || null
        data.pessoa.cod_grup_pes = data.pessoa.cod_grup_pes?.codigo_grup || null
        data.pessoa.cod_catp_pes = data.pessoa.cod_catp_pes?.codigo_catp || null
        data.pessoa.cod_clap_pes = data.pessoa.cod_clap_pes?.codigo_clap || null

        data.pessoa.email_fina_pes = data.pessoa.email_fina_pes || null

        data.pessoa.pessoa_endereco.forEach(e => {
            e.cod_tend_ende = e.cod_tend_ende.codigo_tend
            e.cod_muni_ende = e.cod_muni_ende.codigo_muni
        })

        delete data.meta

        return data

    }
    save(id = null, data = {}) {
        const rs = super.save(id, data).then(pessoa => {
            console.log('After save:', pessoa)
            return pessoa
        })
        console.log('Save antes do return')
        return rs
    }

    async getSchema() {

        return super.getSchema().then((data) => {

            if (data?.fields?.pessoa?.fields) {

                data.fields.pessoa.fields.cpf_cnpj_pes = data.fields.pessoa.fields.cpf_cnpj_pes.test('cpf', 'Cpf incorreto!', isValidCpf)
                data.fields.pessoa.fields.pessoa_endereco.innerType.fields.cod_tend_ende = yup.object().typeError('Obrigatório').required('Obrigatório')
                data.fields.pessoa.fields.pessoa_endereco.innerType.fields.cod_muni_ende = yup.object()
                    .test('municipio', 'Inválido', e => e.codigo_muni)
                    .typeError('Obrigatório')
                    .required('Obrigatório')
            }

            return data

        })

    }

}

